// extracted by mini-css-extract-plugin
export default {"container":"kq-z","ratingLayout":"lq-z","ratingLabel":"mq-z","nonInteractiveRatingLabel":"nq-z"};